enum PairingHelpersEnum {
  "BAY001_PAIRS_AFT" = 1,
  "BAY003_PAIRS_AFT" = 2,
  "NO_PAIRINGS" = 99,
}

export default PairingHelpersEnum;
